import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class IntegrationLogGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var integrationLogGrid = this;
		setTimeout(function(){
			integrationLogGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var integrationLogGrid = this;
		var configIdRefreshTimeout = null;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',					
					postinit: function(combo) {
						Service.getCompanyService().getCompaniesLookup().then(function(data){
							combo.items = data;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							integrationLogGrid.selectedCompanyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							actionRefresh();
						}
					}					
				},				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterModule',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Module',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					postinit: function(combo) {
						DataManagementService.getIntegrationService().getAvailableModules().then(function(data) {
							combo.items = data;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterTransmissionType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Transmission Type',
					'item-value-path': 'transmissionType',
					'item-label-path': 'transmissionDescription',
					postinit: function(combo) {
						DataManagementService.getIntegrationService().getDefinitions().then(function(data){
							combo.items = data;							
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {						
							actionRefresh();
						}
					}					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterConfigId',
					name: 'configId',
					label: 'Config Id',
					maxLength: 120,
					listeners: {
						'value-changed': function() {
							if (configIdRefreshTimeout) {
								clearTimeout(configIdRefreshTimeout);
							}
							configIdRefreshTimeout = setTimeout(function() {
								configIdRefreshTimeout = null;
								actionRefresh();
							}, 2000);
						}
					}
				},				
				{
					tag: 'br'	
				},
				{
					tag: 'vaadin-date-time-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					step: 1,
					value: function() {
						return TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00';	
					}()
				},
				{
					tag: 'vaadin-date-time-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					step: 1,
					value: function() {
						return TimeUtil.formatDateForDateLoad(new Date()) + 'T23:59:59';	
					}()
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'visualize',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:chart', ' Visualize')
					], 
					listeners: {
						click: function() {
							actionShowVisualization();
						}
					}
				}
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [			
				{						
					path: 'configId',
					header: 'ConfigId',
					width: '7em'
				},
				{						
					path: 'companyName',
					header: 'Company Name',
					width: '10em'
				},
				{						
					path: 'nodeId',
					header: 'Node Id',
					width: '7em'
				},				
				{						
					path: 'configFileId',
					header: 'Config File Id',
					width: '7em'
				},
				{						
					path: 'transmissionDescription',
					header: 'Transmission Type',
					width: '7em'
				},
				{						
					path: 'applicationModuleDescription',
					header: 'Module',
					width: '7em'
				},
				{						
					path: 'dataTypeDescription',
					header: 'Data Type',
					width: '7em'
				},
				{						
					path: 'apiVersion',
					header: 'Api Verison',
					width: '7em'
				},				
				{						
					path: 'success',
					header: 'Success',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.success) {
							root.innerHTML = 'Success';
						} else {
							root.innerHTML = 'Fail: ' + rowData.item.failMessage;
						}
					}
				},
				{						
					path: 'recordsPulled',
					header: 'Records Pulled',
					width: '7em'
				},	
				{						
					path: 'latestDataDts',
					header: 'Latest Data Pull',
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.latestDataDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				},
				{						
					path: 'pullStartDts',
					header: 'Pull Start Dts',
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.pullStartDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				},
				{						
					path: 'pullEndDts',
					header: 'Pull End Dts',
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.pullEndDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				},				
				{						
					path: 'dataStartDts',
					header: 'Data Start Dts',
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.dataStartDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				},				
				{						
					path: 'dataEndDts',
					header: 'Data End Dts',
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.dataEndDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {					
				} else {
				}					
			});
		};

		var buildCurrentFilter = function(pageRange, backingGrid) {
			var startFilterDts = TimeUtil.addCompanyTimeZone(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
			var endFilterDts =  TimeUtil.addCompanyTimeZone(ElementUtil.query(toolbarFilter, 'filterEndDate').value);
			var currentFilter = {
				offset: pageRange.offset,
				max: pageRange.max,
				sortField: backingGrid && backingGrid.currentSortField ? backingGrid.currentSortField : (grid.currentSortField ? grid.currentSortField : 'pullStartDts'),
				sortOrder: backingGrid && backingGrid.currentSortDirection ? backingGrid.currentSortDirection : (grid.currentSortDirection ? grid.currentSortDirection : 'ASC'),								
				start: startFilterDts,														
				end: endFilterDts,
				dateField: 'pullStartDts'
			};

			var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;						
			var configId = ElementUtil.query(toolbarFilter, 'filterConfigId').value;
			var appModule = ElementUtil.query(toolbarFilter, 'filterModule').value;
			var transmissionType = ElementUtil.query(toolbarFilter, 'filterTransmissionType').value;

			if (configId && String(configId).trim()) {
				currentFilter.configId = String(configId).trim();
			}
			if (companyId) {
				currentFilter.companyId = companyId;
			}
			if (appModule) {
				currentFilter.applicationModule = appModule;
			}
			if (transmissionType) {
				currentFilter.transmissionType = transmissionType;
			}
			return currentFilter;
		};

		var GROUP_BY_COMPANY = 'company';
		var GROUP_BY_TRANSMISSION = 'transmission';
		var GROUP_BY_MODULE = 'module';
		var GROUP_BY_PULL_START = 'pullStart';

		var CHART_TYPE_BAR = 'bar';
		var CHART_TYPE_LINE = 'line';
		var CHART_TYPE_FILL_LINE = 'fillLine';

		var resolveGroupFields = function(groupBy, row) {
			if (groupBy === GROUP_BY_TRANSMISSION) {
				return {
					key: row.transmissionType || '(None)',
					label: row.transmissionDescription || row.transmissionType || '(None)'
				};
			}
			if (groupBy === GROUP_BY_MODULE) {
				return {
					key: row.applicationModule || '(None)',
					label: row.applicationModuleDescription || row.applicationModule || '(None)'
				};
			}
			if (groupBy === GROUP_BY_PULL_START) {
				var pullStart = TimeUtil.parseDate(row.pullStartDts);
				if (!pullStart) {
					return {
						key: '(None)',
						label: '(None)',
						sortValue: Number.POSITIVE_INFINITY
					};
				}
				return {
					key: String(pullStart.getTime()),
					label: TimeUtil.formatDateStandard(pullStart),
					sortValue: pullStart.getTime()
				};
			}
			return {
				key: row.companyId || '(None)',
				label: row.companyName || row.companyId || '(None)'
			};
		};

		var aggregatePageRows = function(rows, groupBy) {
			var totalsByKey = {};
			var labelByKey = {};
			var sortValueByKey = {};
			(rows || []).forEach(function(row) {
				var groupFields = resolveGroupFields(groupBy, row);
				var recordsPulled = row.recordsPulled != null ? Number(row.recordsPulled) : 0;
				if (isNaN(recordsPulled)) {
					recordsPulled = 0;
				}
				totalsByKey[groupFields.key] = (totalsByKey[groupFields.key] || 0) + recordsPulled;
				labelByKey[groupFields.key] = groupFields.label;
				if (groupFields.sortValue != null) {
					sortValueByKey[groupFields.key] = groupFields.sortValue;
				}
			});

			var sortedKeys = Object.keys(totalsByKey).sort(function(leftKey, rightKey) {
				if (groupBy === GROUP_BY_PULL_START) {
					return (sortValueByKey[leftKey] || 0) - (sortValueByKey[rightKey] || 0);
				}
				return totalsByKey[rightKey] - totalsByKey[leftKey];
			});

			return {
				labels: sortedKeys.map(function(key) {
					return labelByKey[key];
				}),
				values: sortedKeys.map(function(key) {
					return totalsByKey[key];
				})
			};
		};

		var findPageTimeRange = function(rows) {
			var minTime = null;
			var maxTime = null;
			(rows || []).forEach(function(row) {
				var pullStart = TimeUtil.parseDate(row.pullStartDts);
				if (!pullStart) {
					return;
				}
				var millis = pullStart.getTime();
				if (minTime === null || millis < minTime) {
					minTime = millis;
				}
				if (maxTime === null || millis > maxTime) {
					maxTime = millis;
				}
			});
			return {
				start: minTime != null ? new Date(minTime) : null,
				end: maxTime != null ? new Date(maxTime) : null
			};
		};

		var buildChartConfig = function(aggregated, chartType) {
			var selectedChartType = chartType || CHART_TYPE_BAR;
			var isLine = selectedChartType === CHART_TYPE_LINE || selectedChartType === CHART_TYPE_FILL_LINE;
			var dataset = {
				label: 'Records Pulled',
				data: aggregated.values,
				borderWidth: 2
			};
			if (isLine) {
				dataset.tension = 0.2;
				dataset.fill = selectedChartType === CHART_TYPE_FILL_LINE;
			}

			return {
				type: isLine ? 'line' : 'bar',
				data: {
					labels: aggregated.labels,
					datasets: [dataset]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					scales: {
						y: {
							beginAtZero: true,
							title: {
								display: true,
								text: 'Records Pulled'
							}
						},
						x: {
							ticks: {
								maxRotation: 45,
								minRotation: 0,
								autoSkip: true
							}
						}
					}
				}
			};
		};
	
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
						grid.currentFilter = buildCurrentFilter(pageRange, backingGrid);
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
																	
						};						
						
						DataManagementService.getIntegrationService().getIntegrationsLogs(grid.currentFilter).then(function(records){
							successHandler(records);
						});		

					};	
					
					loadData();														
				};
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				DataManagementService.getIntegrationService().exportIntegrationsLogs(exportFilter);
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		integrationLogGrid.append(flexLayout);	
		
		var actionRefresh = function() {
			if (configIdRefreshTimeout) {
				clearTimeout(configIdRefreshTimeout);
				configIdRefreshTimeout = null;
			}
			pagingToolbar.loadPage(1);	
		};

		var actionShowVisualization = function() {
			var chartWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Integration Data Flow',
				icon: 'vaadin:chart',
				scope: 'content',
				width: .75,
				height: .75,
				fillContent: true,
				listeners: {
					ready: function() {
						chartWin.show();

						var currentPageRows = [];
						var selectedGroupBy = GROUP_BY_COMPANY;
						var selectedChartType = CHART_TYPE_BAR;
						var chartPanel = null;

						var startLabel = ElementUtil.create({
							tag: 'span',
							itemid: 'dataStartLabel',
							style: 'margin-right: 16px;',
							innerHTML: 'Start: —'
						});
						var endLabel = ElementUtil.create({
							tag: 'span',
							itemid: 'dataEndLabel',
							innerHTML: 'End: —'
						});

						var updateTimeRangeLabels = function(rows) {
							var timeRange = findPageTimeRange(rows);
							startLabel.textContent = 'Start: ' + (timeRange.start ? TimeUtil.formatDateStandard(timeRange.start) : '—');
							endLabel.textContent = 'End: ' + (timeRange.end ? TimeUtil.formatDateStandard(timeRange.end) : '—');
						};

						var refreshChart = function() {
							if (!chartPanel) {
								return;
							}
							var aggregated = aggregatePageRows(currentPageRows, selectedGroupBy);
							chartPanel.updateChart(buildChartConfig(aggregated, selectedChartType));
						};

						var groupByCombo = ElementUtil.create({
							tag: 'vaadin-combo-box',
							itemid: 'groupBy',
							'class': 'spacer-toolbar-item',
							style: 'width: 220px;',
							label: 'Group By',
							'item-value-path': 'code',
							'item-label-path': 'description',
							postinit: function(combo) {
								combo.items = [
									{ code: GROUP_BY_COMPANY, description: 'Company Name' },
									{ code: GROUP_BY_TRANSMISSION, description: 'Transmission Type' },
									{ code: GROUP_BY_MODULE, description: 'Application Module' },
									{ code: GROUP_BY_PULL_START, description: 'Pull Start Dts' }
								];
								combo.value = GROUP_BY_COMPANY;
							},
							listeners: {
								change: function() {
									selectedGroupBy = groupByCombo.value || GROUP_BY_COMPANY;
									refreshChart();
								}
							}
						});

						var chartTypeCombo = ElementUtil.create({
							tag: 'vaadin-combo-box',
							itemid: 'chartType',
							'class': 'spacer-toolbar-item',
							style: 'width: 160px;',
							label: 'Chart Type',
							'item-value-path': 'code',
							'item-label-path': 'description',
							postinit: function(combo) {
								combo.items = [
									{ code: CHART_TYPE_BAR, description: 'Bar' },
									{ code: CHART_TYPE_LINE, description: 'Line' },
									{ code: CHART_TYPE_FILL_LINE, description: 'Fill Line' }
								];
								combo.value = CHART_TYPE_BAR;
							},
							listeners: {
								change: function() {
									selectedChartType = chartTypeCombo.value || CHART_TYPE_BAR;
									refreshChart();
								}
							}
						});

						var dialogToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							theme: 'spacing',
							children: [
								groupByCombo,
								chartTypeCombo,
								startLabel,
								endLabel
							]
						});

						chartPanel = ElementUtil.create({
							tag: 'dl-chart-panel',
							style: 'flex: 1 1 auto; min-height: 320px; width: 100%;',
							listeners: {
								ready: function() {
									refreshChart();
								}
							}
						});

						var chartBackingGrid = {
							currentSortField: grid.currentSortField,
							currentSortDirection: grid.currentSortDirection
						};

						var chartPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							pageSize: 100,
							postinit: function(element) {
								element.grid = chartBackingGrid;
								element.loader = function(backingGrid, pageNumber, chartPager) {
									var pageRange = chartPager.pullRange();
									var filter = buildCurrentFilter(pageRange, backingGrid);
									var loadMask = chartPanel.showLoading();
									DataManagementService.getIntegrationService().getIntegrationsLogs(filter).then(function(records) {
										currentPageRows = records.data || [];
										chartPager.totalRecords = records.totalNumber;
										chartPager.updatePager();
										updateTimeRangeLabels(currentPageRows);
										refreshChart();
									}).finally(function() {
										loadMask.remove();
									});
								};
							},
							listeners: {
								ready: function() {
									var startingPage = pagingToolbar.currentPage || 1;
									chartPagingToolbar.loadPage(startingPage);
								}
							}
						});

						var contentLayout = ElementUtil.create({
							tag: 'div',
							style: 'display: flex; flex-direction: column; height: 100%; width: 100%; gap: 8px; box-sizing: border-box; padding: 8px;',
							children: [
								dialogToolbar,
								chartPanel,
								chartPagingToolbar
							]
						});

						chartWin.addToContentElement(contentLayout);
					}
				}
			});
		};

		var hadPendingWorkspaceFilters = (function() {
			var node = integrationLogGrid;
			while (node) {
				if (node.pendingWorkspaceFilters) {
					return true;
				}
				if (node.classList && node.classList.contains('page-pane')) {
					break;
				}
				node = node.parentElement;
			}
			return false;
		})();

		attachWorkspaceFilterState(integrationLogGrid, toolbarFilter, ['filterCompany','filterModule','filterTransmissionType','filterConfigId','filterStartDate','filterEndDate'], actionRefresh);

		if (!hadPendingWorkspaceFilters) {
			pagingToolbar.loadCurrentPage();
		}
				
	}
	
}
customElements.define('dl-integration-logs-grid', IntegrationLogGrid);
